import AttendanceItemV4 from './AttendanceItemV4';
import useEventHandleMission from '../../hook/useEventHandleMission';
import {IAttendanceItemV4, IAttendanceModuleV4} from '../../type';
import ModuleSectionV4 from '../ModuleSectionV4';

interface IProps {
  data: IAttendanceModuleV4;
}

export default function MissionAttendanceModuleV4({data}: IProps) {
  const {section, attendanceList} = data;

  const handleMission = useEventHandleMission();
  const handleClickAttendance = (
    {isCurrent, isCompleted, attendanceCount}: IAttendanceItemV4,
    index: number
  ) => {
    handleMission({
      actionName: 'attendance_check',
      customProps: {attendance_num: attendanceCount},
      index,
      disabled: !isCurrent || isCompleted,
    });
  };

  return (
    <ModuleSectionV4
      section={section}
      innerClassName="flex flex-col gap-y-4"
      data-module-type="attendance"
    >
      {attendanceList.map((item, index) => (
        <AttendanceItemV4
          key={index}
          item={item}
          onClick={item => handleClickAttendance(item, index)}
        />
      ))}
    </ModuleSectionV4>
  );
}
